/* ahm-concierge.js — concierge sections (Shopify version of the mockup's js/concierge.js).
   Registers two views with the core (window.M, assets/ahm-core.js):
   - 'concierge' : home sections home-concierge / home-showrooms / home-trust / home-invite
                   (markup server-rendered by Liquid; this fills the live counts, thumbnails, WhatsApp links)
   - 'find'      : the Find-me-a-car request page (sections/main-find.liquid)
   and binds the contact page's general enquiry form (sections/main-contact.liquid; not a slot, no feed).
   Every count comes from the stock feed (M.cars) or the network pack (server-rendered). Nothing invented.
   Loaded by several sections: the guard below keeps it to one execution. */
(function () {
  'use strict';
  if (!window.M || window.__ahmConcierge) return;
  window.__ahmConcierge = 1;
  var M = window.M;

  /* ======================================================================
     Shared bits
     ====================================================================== */
  function $(el, s) { return el.querySelector(s); }
  function $$(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function plural(n, one, many) { return n === 1 ? one : many; }
  /* Shopify CDN images carry &width=720; ask for a small rendition for thumbnails */
  function smallSrc(url, w) { url = String(url || ''); return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url; }
  function thumbImg(p) {
    if (!p || !p.m) return '';
    var w = p.w || 3, h = p.h || 2;
    return '<img src="' + M.esc(smallSrc(p.m, 240)) + '" srcset="' + M.esc(smallSrc(p.m, 240)) + ' 240w, ' + M.esc(smallSrc(p.m, 480)) + ' 480w" sizes="160px" alt="" width="240" height="' + Math.round(240 * h / w) + '" loading="lazy" decoding="async">';
  }

  /* ======================================================================
     CONCIERGE (home)
     ====================================================================== */
  M.view('concierge', {
    render: function (el, ctx) {
      var cars = ctx.cars || [];

      /* WhatsApp: the ONE setting (M.waLink sends people to the contact page when it is blank) */
      $$(el, '[data-cg-wa]').forEach(function (a) { M.waApply(a, 'Hi AHIHQ Motors, I would like help finding a car.'); });

      /* Showrooms: live counts + thumbnails from the cars on this website. City only — never an address. */
      $$(el, '[data-cg-room]').forEach(function (room) {
        var key = room.getAttribute('data-cg-room');
        var city = key.charAt(0).toUpperCase() + key.slice(1);
        var here = [];
        for (var i = 0; i < cars.length; i++) { var c = cars[i]; if (c.status === 'in' && String(c.loc || '').toLowerCase() === key) here.push(c); }

        var live = $(room, '[data-cg-live]'); if (live) live.textContent = M.fmt(here.length);
        var word = $(room, '[data-cg-live-word]'); if (word) word.textContent = plural(here.length, 'car', 'cars');
        var lw = $(room, '[data-cg-live-wrap]'); if (lw) lw.classList.remove('is-pending');

        var st = $(room, '[data-cg-stock]'); if (st) st.setAttribute('href', M.stockUrl({ loc: key }));
        var wa = $(room, '[data-cg-view-wa]');
        if (wa) {
          M.waApply(wa, 'Hi AHIHQ Motors, I would like to arrange a viewing in ' + city + '.');
          wa.setAttribute('aria-label', 'Arrange a viewing in ' + city + ' on WhatsApp');
        }

        var ul = $(room, '[data-cg-thumbs]');
        if (ul) {
          // Preview cars: road cars whose first photo is checked clean (hero-ok) lead, newest model year first;
          // then other road cars (shown without a photo); non-road vehicles (jet skis, tractors) last.
          var nonRoad = /tractor|truck|bus|motor|jet ?ski|trailer/i;
          var tier = function (c) { return (c.hero === true && c.photos && c.photos.length ? 0 : 1) + (nonRoad.test(c.body || '') ? 2 : 0); };
          var pick = here.slice().sort(function (a, b) { return tier(a) - tier(b) || (Number(b.year) || 0) - (Number(a.year) || 0); });
          var show = here.length > 4 ? pick.slice(0, 3) : pick;
          ul.innerHTML = show.map(function (c) {
            var p = c.hero === true ? M.photoOf(c) : null; // an unchecked photo is never used as a preview
            return '<li class="cg-thumb"><a href="' + M.esc(c.url) + '">' +
              '<span class="cg-thumb__img">' + thumbImg(p) + '</span>' +
              '<span class="cg-thumb__t"><span class="cg-thumb__make">' + M.esc(c.make) + '</span><span class="cg-thumb__model">' + M.esc(c.model) + ' <span class="t-num">' + M.esc(c.year) + '</span></span></span>' +
              '</a></li>';
          }).join('') +
            (here.length > show.length ? '<li class="cg-thumb cg-thumb--more"><a href="' + M.esc(M.stockUrl({ loc: key })) + '"><span class="t-num">+' + M.fmt(here.length - show.length) + '</span> more here</a></li>' : '') +
            (!here.length ? '<li class="cg-thumb cg-thumb--none t-small">No cars from ' + M.esc(city) + ' are on the website right now. Ask us for what is in the showroom.</li>' : '');
        }
      });
    }
  });

  /* ======================================================================
     FIND ME A CAR (/pages/find-me-a-car)
     ====================================================================== */
  var DRAFT_KEY = 'ahm-find-draft';
  /* legacy/mockup budget keys → the option values shared with the home finder */
  var BUDGET_ALIAS = { u1: 'under-1m', 'under-1': 'under-1m', 'under1m': 'under-1m', '0-1m': 'under-1m', '1-2': '1-2m', '2-4': '2-4m', '4-7': '4-7m', '7-12': '7-12m', '12-20': '12-20m', '20+': '20m-plus', '20': '20m-plus', '20m': '20m-plus', '20m+': '20m-plus', '20mplus': '20m-plus' };
  var PAY_ALIAS = { loan: 'finance', hp: 'finance', 'hire-purchase': 'finance', bank: 'finance' };

  function selText(sel) { if (!sel || !sel.value) return ''; var o = sel.options[sel.selectedIndex]; return o ? o.text : ''; }
  function sget() { try { var v = localStorage.getItem(DRAFT_KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function sset(v) { try { localStorage.setItem(DRAFT_KEY, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  function sdel() { try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ } }

  /* Makes: data-driven — every make on the website plus every make in the network pack. */
  function allMakes() {
    var s = {};
    (M.all || []).forEach(function (c) { if (c.make) s[c.make] = 1; });
    Object.keys((M.network && M.network.byMake) || {}).forEach(function (k) { if (k && !/^unknown$/i.test(k)) s[k] = 1; });
    return Object.keys(s).sort(function (a, b) { return a.localeCompare(b); });
  }
  function modelsFor(make) {
    var s = {}, mk = String(make || '').toLowerCase();
    (M.all || []).forEach(function (c) { if (c.model && (!mk || String(c.make).toLowerCase() === mk)) s[c.model] = 1; });
    return Object.keys(s).sort().slice(0, 300);
  }
  /* pick an option value by key or by visible text, forgiving on case; '' when nothing matches */
  function pickOpt(sel, v) {
    if (!sel || v == null || v === '') return '';
    v = String(v).toLowerCase();
    for (var i = 0; i < sel.options.length; i++) { var o = sel.options[i]; if (o.value && (o.value.toLowerCase() === v || o.text.toLowerCase() === v)) return o.value; }
    return '';
  }
  function cleanRef(r) { r = String(r || '').trim(); return /^[A-Za-z0-9][A-Za-z0-9-]{1,31}$/.test(r) ? r : ''; }

  function readForm(el) {
    var f = $(el, '[data-fd-form]'); if (!f) return {};
    var r = f.querySelector('input[name="trans"]:checked');
    return {
      make: f.elements.make.value.trim(), model: f.elements.model.value.trim(),
      needs: $$(el, '[data-fd-need][aria-pressed="true"]').map(function (b) { return b.getAttribute('data-fd-need'); }),
      year: f.elements.year.value, trans: r ? r.value : '', budget: f.elements.budget.value, when: f.elements.when.value, pay: f.elements.pay.value,
      notes: f.elements.notes.value.trim(), name: f.elements.name.value.trim(), phone: f.elements.phone.value.trim(),
      ref: el._fdRef || ''
    };
  }
  function writeForm(el, d) {
    var f = $(el, '[data-fd-form]'); if (!f || !d) return;
    ['make', 'model', 'notes', 'name', 'phone'].forEach(function (k) { if (d[k] != null) f.elements[k].value = d[k]; });
    ['year', 'budget', 'when', 'pay'].forEach(function (k) { if (d[k] != null) { var s = f.elements[k]; s.value = d[k]; if (s.value !== d[k]) s.value = ''; } });
    if (d.trans != null) { var r = f.querySelector('input[name="trans"][value="' + (d.trans === 'Automatic' || d.trans === 'Manual' ? d.trans : '') + '"]'); if (r) r.checked = true; }
    if (d.needs) $$(el, '[data-fd-need]').forEach(function (b) { b.setAttribute('aria-pressed', d.needs.indexOf(b.getAttribute('data-fd-need')) > -1 ? 'true' : 'false'); });
    el._fdRef = cleanRef(d.ref);
    updateModels(el);
  }
  function updateModels(el) {
    var f = $(el, '[data-fd-form]'); var dl = $(el, '#fd-models'); if (!f || !dl) return;
    dl.innerHTML = modelsFor(f.elements.make.value.trim()).map(function (m) { return '<option value="' + M.esc(m) + '"></option>'; }).join('');
  }

  /* Map query params (?need=&make=&budget=&ref=… from the home finder, car pages, stock) onto the form. */
  function fromParams(el, p) {
    var d = {}; if (!p) return d;
    var f = $(el, '[data-fd-form]');
    if (p.make) d.make = String(p.make).replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); }).replace(/^Bmw$/, 'BMW');
    if (p.model) d.model = p.model;
    if (p.q && !p.make && !p.model) d.notes = 'Looking for: ' + p.q;
    var needs = String(p.need || p.needs || '').split(/[,\s]+/).map(function (k) { return k === 'low' ? 'lowkm' : k; }).filter(function (k) { return k && !!$(el, '[data-fd-need="' + k + '"]'); });
    if (needs.length) d.needs = needs;
    var yr = p.year || p.yearFrom;
    if (yr) { var y = String(yr).replace(/\D/g, ''); if (y.length === 4) d.year = pickOpt(f.elements.year, y); }
    if (p.budget) { var b = String(p.budget).toLowerCase().replace(/\s/g, ''); d.budget = pickOpt(f.elements.budget, BUDGET_ALIAS[b] || b); }
    /* finder filters with no field of their own go into the notes, so nothing the visitor chose is lost */
    var extra = [];
    if (p.body) extra.push('Body: ' + p.body);
    if (p.fuel) extra.push('Fuel: ' + p.fuel);
    if (p.drive) extra.push('Drive: ' + p.drive);
    if (p.kmMax && /^\d+$/.test(p.kmMax)) extra.push('Mileage: under ' + M.km(+p.kmMax));
    if (p.status === 'in') extra.push('Here now only'); else if (p.status === 'way') extra.push('Arriving is fine');
    if (p.loc && /^(nairobi|mombasa)$/i.test(p.loc)) extra.push('City: ' + p.loc.charAt(0).toUpperCase() + p.loc.slice(1).toLowerCase());
    if (extra.length) d.notes = (d.notes ? d.notes + ' ' : '') + extra.join('. ') + '.';
    if (p.when) d.when = pickOpt(f.elements.when, p.when);
    if (p.trans) { var t = String(p.trans).toLowerCase(); d.trans = /^a/.test(t) ? 'Automatic' : /^m/.test(t) ? 'Manual' : ''; }
    if (p.pay) { var pv = String(p.pay).toLowerCase(); d.pay = pickOpt(f.elements.pay, PAY_ALIAS[pv] || pv); }
    var ref = cleanRef(p.ref); if (ref) d.ref = ref;
    return d;
  }

  function message(el, d) {
    var f = $(el, '[data-fd-form]');
    var L = ['Hi AHIHQ Motors, please find me a car.'];
    if (d.ref) {
      var car = M.byRef(d.ref);
      L.push('Something like: ' + (car ? car.title + ' (Ref ' + car.ref + ') ' + M.carUrl(car) : 'Ref ' + d.ref));
    }
    var what = [d.make, d.model].filter(Boolean).join(' ');
    L.push('Car: ' + (what || 'Open to suggestions'));
    if (d.needs && d.needs.length) L.push('For: ' + d.needs.map(function (k) { var b = $(el, '[data-fd-need="' + k + '"]'); return b ? b.textContent.trim() : k; }).join(', '));
    if (d.year) L.push('Year: ' + d.year + ' or newer');
    if (d.trans) L.push('Transmission: ' + d.trans);
    if (d.budget) L.push('Budget: ' + selText(f.elements.budget));
    if (d.when) L.push('When: ' + selText(f.elements.when));
    if (d.pay) L.push('Paying by: ' + selText(f.elements.pay));
    if (d.notes) L.push('Notes: ' + d.notes);
    L.push('Name: ' + (d.name || '…'));
    L.push('Phone: ' + (d.phone || '…'));
    return L.join('\n');
  }

  function validate(el, d, show) {
    var okName = !!d.name, okPhone = (d.phone || '').replace(/\D/g, '').length >= 9;
    if (show) {
      [['name', okName], ['phone', okPhone]].forEach(function (x) {
        var inp = $(el, '#fd-' + x[0]), err = $(el, '#fd-' + x[0] + '-err');
        if (inp) inp.setAttribute('aria-invalid', x[1] ? 'false' : 'true');
        if (err) err.hidden = x[1];
      });
    }
    return okName && okPhone;
  }

  function refresh(el, opts) {
    var d = readForm(el);
    var msg = message(el, d);
    var pre = $(el, '[data-fd-preview]'); if (pre) pre.textContent = msg;
    var a = $(el, '[data-fd-send]'); if (a) M.waApply(a, msg);
    var cl = $(el, '[data-fd-count-line]');
    if (cl) { var n = (M.cars || []).length; cl.textContent = n ? 'Rather look first? ' + M.fmt(n) + ' ' + plural(n, 'car is', 'cars are') + ' on the website now.' : 'Rather look first? Browse what is on the website now.'; }
    var from = $(el, '[data-fd-from]');
    if (from) {
      var car = d.ref ? M.byRef(d.ref) : null;
      from.hidden = !car;
      if (!car) from.removeAttribute('data-ref');
      if (car && from.getAttribute('data-ref') !== car.ref) {
        from.setAttribute('data-ref', car.ref);
        from.innerHTML = '<span class="fd-from__img">' + thumbImg(M.photoOf(car)) + '</span>' +
          '<span class="fd-from__t"><span class="t-label-s">Starting from</span><span>' + M.esc(car.title) + ' <span class="fd-from__ref t-num">Ref ' + M.esc(M.shortRef(car)) + '</span></span></span>' +
          '<button type="button" class="icon-btn icon-btn--bare fd-from__x" data-fd-unref aria-label="Remove the starting car">' + M.icon('close', { size: 18 }) + '</button>';
      }
    }
    if (!opts || !opts.noSave) sset(d);
  }

  function bindFind(el) {
    if (el._fdBound || !$(el, '[data-fd-form]')) return;
    el._fdBound = true;
    var dl = $(el, '#fd-makes');
    if (dl) dl.innerHTML = allMakes().map(function (m) { return '<option value="' + M.esc(m) + '"></option>'; }).join('');
    var draft = sget(); if (draft) writeForm(el, draft);

    el.addEventListener('input', function (e) {
      if (e.target.name === 'make') updateModels(el);
      if (e.target.getAttribute('aria-invalid') === 'true' && validate(el, readForm(el), true)) { var sc = $(el, '[data-fd-status]'); if (sc) sc.textContent = ''; }
      refresh(el);
    });
    el.addEventListener('change', function () { refresh(el); });
    el.addEventListener('click', function (e) {
      var nb = e.target.closest('[data-fd-need]');
      if (nb) { nb.setAttribute('aria-pressed', nb.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); refresh(el); return; }
      if (e.target.closest('[data-fd-unref]')) { el._fdRef = ''; refresh(el); var mk = $(el, '#fd-make'); if (mk) mk.focus(); return; }
      if (e.target.closest('[data-fd-reset]')) {
        var f = $(el, '[data-fd-form]'); f.reset(); el._fdRef = '';
        $$(el, '[data-fd-need]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        $$(el, '.fd-err').forEach(function (x) { x.hidden = true; }); $$(el, '[aria-invalid]').forEach(function (x) { x.removeAttribute('aria-invalid'); });
        sdel(); updateModels(el); refresh(el, { noSave: true });
        var stc = $(el, '[data-fd-status]'); if (stc) stc.textContent = 'Cleared.';
        var mk2 = $(el, '#fd-make'); if (mk2) mk2.focus();
        return;
      }
      var send = e.target.closest('[data-fd-send]');
      if (send) {
        var d = readForm(el);
        var status = $(el, '[data-fd-status]');
        if (!validate(el, d, true)) {
          e.preventDefault(); e.stopPropagation();
          if (status) status.textContent = 'Two details are needed before we can reply: your name and a phone number.';
          var bad = $(el, '[aria-invalid="true"]'); if (bad) bad.focus();
          return;
        }
        refresh(el); /* the href is current */
        if (status) status.textContent = send.getAttribute('data-wa-missing') ? 'WhatsApp is not set up on the website yet, so we are taking you to our contact details.' : 'Opening WhatsApp with your request.';
      }
    });
    /* Enter in a text field must not leave the page */
    el.addEventListener('submit', function (e) { e.preventDefault(); var s = $(el, '[data-fd-send]'); if (s) s.click(); });
  }

  M.view('find', {
    init: function (el) { bindFind(el); },
    render: function (el, ctx) {
      bindFind(el);
      if (!el._fdParamsDone) {
        el._fdParamsDone = true;
        var d = fromParams(el, (ctx.route || {}).params);
        if (Object.keys(d).length) writeForm(el, Object.assign(readForm(el), d));
      }
      refresh(el, { noSave: true });
    }
  });

  /* ======================================================================
     CONTACT (/pages/contact) — general enquiry → WhatsApp. Not a slot: no stock feed needed.
     ====================================================================== */
  function contactMessage(f) {
    var topic = f.elements.topic ? f.elements.topic.value : '';
    var msg = f.elements.text ? f.elements.text.value.trim() : '';
    var name = f.elements.name ? f.elements.name.value.trim() : '';
    var L = ['Hi AHIHQ Motors' + (name ? ', this is ' + name : '') + '.'];
    if (topic) L.push('About: ' + topic);
    if (msg) L.push(msg);
    return L.join('\n');
  }
  function bindContact(root) {
    if (!root || root._ctBound) return;
    root._ctBound = true;
    $$(root, '[data-ct-wa]').forEach(function (a) { M.waApply(a, 'Hi AHIHQ Motors, '); });
    var f = $(root, '[data-ct-form]'); if (!f) return;
    var send = $(f, '[data-ct-send]'), status = $(f, '[data-ct-status]');
    function upd() { if (send) M.waApply(send, contactMessage(f)); }
    upd();
    f.addEventListener('input', upd);
    f.addEventListener('change', upd);
    f.addEventListener('submit', function (e) { e.preventDefault(); if (send) send.click(); });
    f.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ct-send]')) return;
      var msg = f.elements.text ? f.elements.text.value.trim() : '';
      if (!msg) {
        e.preventDefault();
        if (status) status.textContent = 'Write your message first, then send it.';
        if (f.elements.text) f.elements.text.focus();
        return;
      }
      upd();
      if (status) status.textContent = 'Opening WhatsApp with your message.';
    });
  }
  function bindContacts() { document.querySelectorAll('[data-ct]').forEach(bindContact); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindContacts); else bindContacts();

  /* Theme editor: a re-rendered section brings fresh markup; bind it again. */
  document.addEventListener('shopify:section:load', function () {
    bindContacts();
    if (document.querySelector('[data-slot="concierge"], [data-slot="find"]')) M.rerender();
  });
})();
